import { StoreState } from './store.types';

export function getCustomer(state: StoreState) {
  return state.customer;
}

export function getRequest(state: StoreState) {
  return state.request;
}

export function getDisqualification(state: StoreState) {
  return state.disqualification;
}
